import './style.scss';
import psl_actions from '../../libs/psl_actions.js';
import psl_ui from '../../libs/psl_ui.js';
import template from './template.pst';
import template_mark from './template_mark.pst';

import {wait} from '../../libs/psl_polyfills.js';

import data from "../../data.js";
import analytics from '../analytics/component.js';

import CONFIG from '../../CONFIG.js';

psl_ui.templates.add('maps',template);
psl_ui.templates.add('maps_mark',template_mark);

psl_actions.add('maps.show',(e,uid)=>{
	analytics.track_popup_open(uid);
	let map_data = data.maps.find(map_data=>map_data.uid===uid);

	if(!map_data) return;

	maps.render(map_data);

	maps.view.classList.add('open');
});

psl_actions.add('maps.hide',()=>{
	maps.view.classList.remove('open');
});

let current_mark;

psl_actions.add('maps.mark.toggle',e=>{
	const mark=psl_ui.DOM.parent(e.target,el=>el.classList.contains('mark'));
	if(!mark) return;
	mark.classList.toggle('opened');

	if(mark.classList.contains('opened')){
		if(current_mark && current_mark!==mark) current_mark.classList.remove('opened');
	}
	current_mark=mark;
});

const _preview_max=320;

const _center = (e)=>{
	const t=e.touches;
	return {
		x:(t[0].clientX+t[1].clientX)/2,
		y:(t[0].clientY+t[1].clientY)/2
	};
}

const _dist = (e)=>{
	const t=e.touches;
	return Math.sqrt(Math.pow(t[0].clientX-t[1].clientX,2)+Math.pow(t[0].clientY-t[1].clientY,2));
}

class Maps{
	constructor(){
		const {el, rpoints} = psl_ui.templates.render('maps');

		this._rpoints=rpoints;
		this.view=el;
		this.view.controller=this;

		this._state={};

		this._rpoints.img.addEventListener('load',()=>{

			const zoom=Math.max(Math.max(window.innerWidth/this._rpoints.img.clientWidth,this.view.clientHeight/this._rpoints.img.clientHeight),1);

			this._geometry={
				width:this._rpoints.img.clientWidth,
				height:this._rpoints.img.clientHeight,
				x:(window.innerWidth-this._rpoints.img.clientWidth*zoom)/2,
				y:(this.view.clientHeight-this._rpoints.img.clientHeight*zoom)/2,
				zoom
			}

			this._update_preview_scale();
		});

		window.addEventListener('resize',()=>this._update_preview_scale());

		this._rpoints.content.addEventListener('mousewheel',e=>{
			const old_zoom=this._geometry.zoom;
			this._geometry_zoom=this._geometry.zoom-e.deltaY/24/100;
			const zoom_delta=this._geometry.zoom-old_zoom;
			if(zoom_delta!==0){
				this._geometry_x=this._geometry.x-this._geometry.width/2*zoom_delta;
				this._geometry_y=this._geometry.y-this._geometry.height/2*zoom_delta;
			}
			this._apply_geometry();
		});

		this._rpoints.content.addEventListener('touchstart',e=>{
			this._old_geometry={...this._geometry};
			switch(e.touches.length){
				case 1:
					this._state.action='move';
					this._state.start_x=e.touches[0].clientX;
					this._state.start_y=e.touches[0].clientY;
				break;
				case 2:
					this._state.action='zoom';
					const center = _center(e);
					this._state.start_x=center.x;
					this._state.start_y=center.y;
					this._state.distance=_dist(e);
				break;
			}
		});

		this._rpoints.content.addEventListener('touchmove',e=>{
			e.stopPropagation();
			e.preventDefault();
			switch(this._state.action){
				case 'move':
					this._geometry_x=this._old_geometry.x-this._state.start_x+e.touches[0].clientX;
					this._geometry_y=this._old_geometry.y-this._state.start_y+e.touches[0].clientY;
					this._apply_geometry();
				break;
				case 'zoom':
					//Ok, next time I should write comments...

					const center = _center(e);
					this._geometry_x = this._old_geometry.x-this._state.start_x+center.x;
					this._geometry_y = this._old_geometry.y-this._state.start_y+center.y;

					const abs_x=(-this._geometry.x+center.x)/this._geometry.zoom;
					const abs_y=(-this._geometry.y+center.y)/this._geometry.zoom;

					let distance = _dist(e);

					const prev = this._geometry.zoom;

					this._geometry_zoom = this._old_geometry.zoom*(distance/this._state.distance);

					const d = this._geometry_zoom-prev;

					this._geometry_x-=abs_x*d;
					this._geometry_y-=abs_y*d;

					this._old_geometry.x=this._geometry.x;
					this._old_geometry.y=this._geometry.y;
					this._state.start_x=center.x;
					this._state.start_y=center.y;

					this._apply_geometry();

				break;
			}
		});

		this._rpoints.content.addEventListener('touchend',e=>{
			switch(e.touches.length){
				case 1:
					this._state.action='move';
					this._state.start_x=e.touches[0].clientX;
					this._state.start_y=e.touches[0].clientY;
					this._old_geometry={...this._geometry};
				break;
				default:
					this._state.action='';
				break;
			}
		});

		this._rpoints.content.addEventListener('mousedown',e=>{
			this._old_geometry={...this._geometry};
			this._state.action='move';
			this._state.start_x=e.clientX;
			this._state.start_y=e.clientY;
		});

		this._rpoints.content.addEventListener('mousemove',e=>{
			if(this._state.action==='move'){
				e.stopPropagation();
				e.preventDefault();
				this._geometry_x=this._old_geometry.x-this._state.start_x+e.clientX;
				this._geometry_y=this._old_geometry.y-this._state.start_y+e.clientY;
				this._apply_geometry();
			}
		});

		this._rpoints.content.addEventListener('mouseup',e=>{
			this._state.action='';
		});

		document.addEventListener('mouseup',e=>{
			if(this._state.action==='move'){
				this._state.action='';
			}
		});
	}

	get _geometry_x(){return this._geometry.x}
	set _geometry_x(value){
		this._geometry.x=Math.max(window.innerWidth-this._geometry.width*this._geometry.zoom,Math.min(value,0));
	}

	get _geometry_y(){return this._geometry.y}
	set _geometry_y(value){
		this._geometry.y=Math.max(this.view.clientHeight-this._geometry.height*this._geometry.zoom,Math.min(value,0));
	}

	get _geometry_zoom(){return this._geometry.zoom}
	set _geometry_zoom(value){
		this._geometry.zoom=Math.max(Math.max(window.innerWidth/this._geometry.width,this.view.clientHeight/this._geometry.height),Math.min(value,2));
	}

	async render(data){
		this.data=data;
		this._rpoints.back_label.innerHTML=data.back_label||"";
		this._rpoints.name.innerHTML=data.name||"";
		this._rpoints.sub.innerHTML=data.sub||"";
		this._rpoints.desc.innerHTML=data.desc||"";

		this._rpoints.img.src=``;
		this._rpoints.img.src=`${CONFIG.backend_base_url}files/${data.img}`;

		this._rpoints.marks.innerHTML='';
		data.places?.forEach(place=>this._rpoints.marks.appendChild(psl_ui.templates.render('maps_mark',place).el));
	}

	_update_preview_scale(){
		if(!this._geometry) return;
		this._geometry.preview_scale=window.innerWidth<768?(0.25*window.innerWidth)/this._geometry.width:_preview_max/Math.max(this._geometry.width,this._geometry.height);
		this._rpoints.preview.style.width=`${this._geometry.width*this._geometry.preview_scale}px`;
		this._rpoints.preview.style.height=`${this._geometry.height*this._geometry.preview_scale}px`;
		this._apply_geometry();
	}

	_apply_geometry(){
		this._rpoints.img.style.transform=`translate3d(${this._geometry.x}px,${this._geometry.y}px,0px) scale3d(${this._geometry.zoom},${this._geometry.zoom},1)`;

		this._rpoints.screen.style.width=`${window.innerWidth/this._geometry.zoom*this._geometry.preview_scale}px`;
		this._rpoints.screen.style.height=`${this.view.clientHeight/this._geometry.zoom*this._geometry.preview_scale}px`;

		this._rpoints.screen.style.transform=`translate3d(${-this._geometry.x*this._geometry.preview_scale/this._geometry.zoom}px,${-this._geometry.y*this._geometry.preview_scale/this._geometry.zoom}px,0px) `;

		this._rpoints.marks.style.transform=`translate3d(${this._geometry.x}px,${this._geometry.y}px,0px)`;
		this._rpoints.marks.style.width=this._geometry.width*this._geometry.zoom+'px';
		this._rpoints.marks.style.height=this._geometry.height*this._geometry.zoom+'px';
	}
}

const maps = new Maps();

document.body.appendChild(maps.view);

export default maps;
